import 'regenerator-runtime/runtime';
import { call, select, takeEvery } from 'redux-saga/effects';
import { App } from '@ps20-frontend/frontend-models';
import {
  DoRequestResponse,
  GlobalActions,
  ShopTarifierungRequestEvents,
  TarifiereAngebotForShopAction,
} from '@ps20-frontend/shop-integration-redux';
import {
  createHashedTaasData,
  ShopTarifierer,
  ShopTarifierungsErgebnisHandler,
} from '@ps20-frontend/preis-lib';
import { TaasRequestModel, TaasResponseModel, TaasVhvData } from '@ps20/bff-models';
import { CallEffect, ForkEffect, SelectEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { buildTaasVHVDataForShop } from './transformer/vhvData.transformer';

export const shopTarifierungsErgebnisHandler = new ShopTarifierungsErgebnisHandler<
  IAppState,
  TaasVhvData
>(App.VHV, getVereinbarungInfo);
export const shopTarifierer = new ShopTarifierer({
  appId: App.VHV,
  taasDataBuilder: buildTaasVHVDataForShop,
  resultHandler: shopTarifierungsErgebnisHandler,
  hashFunc: createHashedTaasDataVHV,
});

export function* shopTarifierungVHV(): Generator<ForkEffect> {
  yield takeEvery(
    ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_VHV,
    safeSaga(callSuccessOnMatchingAngebotsId, App.VHV),
  );
  yield takeEvery(
    GlobalActions.TARIFIERE_ANGEBOT_FOR_SHOP,
    safeSaga(callTarifierungOnMatchingAngebotsId, App.VHV),
  );
}

export function getVereinbarungInfo(state: IAppState): string {
  const risikoort = state.risikoort;
  const wohnflaeche = state.versObjekt.wohnflaeche;
  const risikoortString = `${risikoort.strasse} ${risikoort.hausnummer}, ${risikoort.plz} ${risikoort.ort}, `;
  const wohnflaecheString = `${wohnflaeche} m²`;
  return `${risikoortString}${wohnflaecheString}`;
}

export function* callTarifierungOnMatchingAngebotsId(
  tarifiereAngebotAction: TarifiereAngebotForShopAction,
): Generator<SelectEffect | CallEffect> {
  const appState: IAppState = (yield select()) as IAppState;
  const angebotsIdIsMatching = appState.angebotsId === tarifiereAngebotAction.payload.angebotsId;

  if (angebotsIdIsMatching) {
    yield call(shopTarifierer.callTarifierung, tarifiereAngebotAction);
  }
}

export function* callSuccessOnMatchingAngebotsId(
  successAction: DoRequestResponse<TaasResponseModel, TaasRequestModel<TaasVhvData>>,
): Generator<SelectEffect | CallEffect> {
  const appState: IAppState = (yield select()) as IAppState;
  const originEvent: TarifiereAngebotForShopAction =
    successAction.doRequestAction.payload.originEvent;
  const angebotsIdIsMatching = appState.angebotsId === originEvent.payload.angebotsId;
  if (angebotsIdIsMatching) {
    yield call(shopTarifierer.handleSuccess, successAction);
  }
}

export function createHashedTaasDataVHV(taasData: TaasVhvData): string {
  const relevantData = { ...taasData };
  relevantData.gisDaten = undefined;
  if (taasData.adresse) {
    relevantData.adresse = {
      plz: taasData.adresse.plz,
      ort: taasData.adresse.ort,
      strasse: taasData.adresse.strasse,
      hausnummer: taasData.adresse.hausnummer,
      latitude: taasData.adresse.latitude,
      longtitude: taasData.adresse.longtitude,
    };
  }
  return createHashedTaasData(relevantData);
}
